import React, { Component } from 'react';
import { connect } from 'react-redux';
import FiltersComponent from './../component';

class GenericFilters extends Component {
  onFilterChange = (event, newValue, previousValue, name) => {
    let tempValues = JSON.parse(JSON.stringify(this.props.filterValues));
    tempValues[name] = newValue;
    this.props.onChange(event, tempValues);
  };
  render() {
    const { onChange } = this.props;
    return (
      <FiltersComponent
        onFilterChange={onChange ? this.onFilterChange : () => {}}
        {...this.props}
      />
    );
  }
}
const mapStateToProps = ({ FiltersState }) => {
  return {};
};
export const GenericFiltersContainer = connect(mapStateToProps)(GenericFilters);



// WEBPACK FOOTER //
// ./src/components/filters/container/index.js